import { useEffect } from "react";
import { X } from "lucide-react";
import { takeFlash } from "@/lib/project-url";
import { useUiStore } from "@/stores/ui-store";

export function Toaster() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);
  const notify = useUiStore((s) => s.notify);

  // "Deleted X" / "You left X" from the page before the last full page load.
  useEffect(() => {
    const message = takeFlash();
    if (message) notify(message);
  }, [notify]);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed right-6 bottom-6 z-50 flex w-84 flex-col gap-2" role="status">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-start gap-3 rounded-lg border px-4 py-3 text-[13px] shadow-lg ${
            toast.tone === "error" ? "border-err-bg bg-err-bg text-err" : "border-line bg-surface text-ink"
          }`}
        >
          <span className="flex-1 leading-relaxed">{toast.message}</span>
          {toast.action && (
            <button
              type="button"
              className="link -my-3 inline-flex min-h-11 min-w-11 items-center justify-center font-medium"
              onClick={() => {
                dismiss(toast.id);
                toast.action?.run();
              }}
            >
              {toast.action.label}
            </button>
          )}
          <button
            type="button"
            onClick={() => dismiss(toast.id)}
            aria-label="Dismiss notification"
            className="-my-3 -mr-2 inline-flex min-h-11 min-w-11 items-center justify-center text-faint hover:text-ink"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
